var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getNextCardId, mockCards, setMockCards } from '@/api/mockApi/_data';
export const mockCharacterApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(mockCards), 300));
    }),
    create: (card) => __awaiter(void 0, void 0, void 0, function* () {
        const newCard = Object.assign(Object.assign({}, card), { id: getNextCardId() });
        mockCards.push(newCard);
        return new Promise((resolve) => setTimeout(() => resolve(newCard), 200));
    }),
    update: (card) => __awaiter(void 0, void 0, void 0, function* () {
        const idx = mockCards.findIndex((c) => c.id === card.id);
        if (idx !== -1) {
            setMockCards(mockCards.map((c) => (c.id === card.id ? Object.assign(Object.assign({}, mockCards[idx]), card) : c)));
        }
        return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, mockCards[idx]), card)), 200));
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        setMockCards(mockCards.filter((c) => c.id !== id));
        return new Promise((resolve) => setTimeout(() => resolve(), 200));
    }),
    updateSpellSlot: (characterId_1, slotId_1, action_1, ...args_1) => __awaiter(void 0, [characterId_1, slotId_1, action_1, ...args_1], void 0, function* (characterId, slotId, action, amount = 1) {
        return new Promise((resolve) => setTimeout(() => resolve(mockCards.find((c) => c.id === characterId)), 200));
    }),
    resetSpellSlots: (characterId) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => {
            const character = mockCards.find((c) => c.id === characterId);
            resolve(character);
        }, 200));
    }),
    longRest: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => {
            const updatedCharacters = [];
            const next = mockCards.map((c) => {
                var _a;
                if (c.health <= 0) {
                    return c;
                }
                const spellSlots = (_a = c.spellSlots) === null || _a === void 0 ? void 0 : _a.map((s) => (Object.assign(Object.assign({}, s), { available: s.count })));
                const merged = Object.assign(Object.assign(Object.assign({}, c), { health: c.maxHealth, tempHealth: 0 }), (spellSlots ? { spellSlots } : {}));
                updatedCharacters.push(merged);
                return merged;
            });
            setMockCards(next);
            resolve({ updatedCharacters });
        }, 200));
    }),
};
export const mockCharactersGroupApi = {
    list: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve([]), 200));
    }),
    create: (group) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({}), 200));
    }),
    update: (group) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({}), 200));
    }),
    delete: (group) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(), 200));
    }),
    addCharacterToGroup: (group, character) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(), 200));
    }),
    removeCharacterFromGroup: (group, character) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(), 200));
    }),
};
